const IMG_OPTION = {
    x: 0,
    y: 0,
    fileType: 'png',
    quality: 1
}

const initImgOption = ({ canvasId, width, height }) => {
    IMG_OPTION.canvasId = canvasId
    IMG_OPTION.width = width
    IMG_OPTION.height = height
}

let task

export default {
    data () {
        return {
            draw_finished: false,
            img_saving: false,
            tmp_img_path: ''
        }
    },
    mounted () {
        this.img_saving = false
        this.draw_finished = false
    },
    destroyed () {
        task && clearTimeout(task)
    },
    watch: {
        draw_finished (latest) {
            console.error('draw_finished', latest, this.img_saving)
            if (latest && this.img_saving) {
                this.saveImg()
            }
        }
    },
    methods: {
        finishDraw ({ canvasId, width, height }) {
            console.error(canvasId, width, height)
            initImgOption({ canvasId, width, height })
            task = setTimeout(() => {
                this.draw_finished = true
            }, 1000)
        },
        save (options = {}) {
            wx.showLoading({
                title: '生成中'
            })
            this.img_saving = true
            if (this.draw_finished) {
                this.saveImg(options)
            }
        },
        saveImg (options = {}) {
            wx.canvasToTempFilePath({
                ...IMG_OPTION,
                success: (res) => {
                    this.tmp_img_path = res.tempFilePath
                    this.saveAlbum(res.tempFilePath)
                    if (options.handleTempFile) {
                        options.handleTempFile(res.tempFilePath)
                    }
                },
                fail: this.saveFail
            }, this.$mp.component)
        },
        saveAlbum (tempFilePath) {
            const saveImageToPhotosAlbum = () => {
                wx.saveImageToPhotosAlbum({
                    filePath: tempFilePath,
                    success: () => {
                        wx.hideLoading()
                        this.saveImgSuccess && this.saveImgSuccess()
                    },
                    fail: this.saveFail
                })
            }
            const checkAuth = () => {
                wx.openSetting({
                    success: ({ authSetting }) => {
                        if (authSetting && authSetting['scope.writePhotosAlbum']) {
                            saveImageToPhotosAlbum()
                        }
                    }
                })
            }
            const authFail = () => {
                this.hideSaveImg && this.hideSaveImg()
                this.finishSave()
                wx.showModal({
                    title: '提示',
                    content: '必须要授权相册权限才可以保存图片',
                    showCancel: false,
                    success: ({ confirm }) => {
                        if (confirm) {
                            checkAuth()
                        }
                    }
                })
            }
            wx.authorize({
                scope: 'scope.writePhotosAlbum',
                success: saveImageToPhotosAlbum,
                fail: authFail
            })
        },
        saveFail (err) {
            this.finishSave()
            this.draw_finished = false
            console.error(err)
            wx.showToast({
                title: '图片保存失败'
            })
        },
        finishSave () {
            wx.hideLoading()
            this.img_saving = false
            this.draw_finished = false
        }
    }
}
